import forge from 'node-forge';

export async function encryptData(data: string) {
  const publicKeyPem = await fetch(`${process.env.REACT_APP_BASE_URL}v1/encryption/pbkey`).then(
    (res: any) => res.text()
  );
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encrypted = publicKey.encrypt(data, 'RSA-OAEP');
  // encode to base64
  const encryptedData = forge.util.encode64(encrypted);
  return encryptedData;
}

export const encryptBulkData = async (data: string[]) => {
  const publicKeyPem = await fetch(`${process.env.REACT_APP_BASE_URL}v1/encryption/pbkey`).then(
    (res: any) => res.text()
  );
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encryptedData = data.map((item) => {
    const encrypted = publicKey.encrypt(item, 'RSA-OAEP');
    return forge.util.encode64(encrypted);
  });
  return encryptedData;
};
